import newsletterService from '../services/newsletterService';

export const fetchAllNewsletters = async (params) => {
  const result = await newsletterService.getAllNewsletters(params);
  if (!result?.success) {
    const error = new Error(result?.message || 'Bültenler alınamadı');
    error.details = result;
    throw error;
  }
  return { data: result.data, meta: result.metaData };
};

export const createNewsletter = async (payload) => {
  const result = await newsletterService.createNewsletter(payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'Bülten oluşturulamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const updateNewsletter = async (payload) => {
  const result = await newsletterService.updateNewsletter(payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'Bülten güncellenemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const deleteNewsletter = async (id) => {
  const result = await newsletterService.deleteNewsletter(id);
  if (!result?.success) {
    const error = new Error(result?.message || 'Bülten silinemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const fetchNewsletterById = async (id) => {
  const result = await newsletterService.getNewsletterById(id);
  if (!result?.success) {
    const error = new Error(result?.message || 'Bülten alınamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const reorderNewsletters = async ({ newsletterIdsInOrder }) => {
  const result = await newsletterService.reorderNewsletters({ newsletterIdsInOrder });
  if (!result?.success) {
    const error = new Error(result?.message || 'Bültenler sıralanamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const publishNewsletter = async ({ id, isPublished }) => {
  const result = await newsletterService.publishNewsletter({ id, isPublished });
  if (!result?.success) {
    const error = new Error(result?.message || 'Bülten yayın durumu güncellenemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const uploadNewsletterCoverImage = async ({ newsletterId, file }) => {
  const result = await newsletterService.uploadNewsletterCoverImage({ newsletterId, file });
  if (!result?.success) {
    const error = new Error(result?.message || 'Kapak görseli yüklenemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const uploadNewsletterPdf = async ({ newsletterId, file }) => {
  const result = await newsletterService.uploadNewsletterPdf({ newsletterId, file });
  if (!result?.success) {
    const error = new Error(result?.message || 'PDF dosyası yüklenemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

export default {
  fetchAllNewsletters,
  createNewsletter,
  updateNewsletter,
  deleteNewsletter,
  fetchNewsletterById,
  reorderNewsletters,
  publishNewsletter,
  uploadNewsletterCoverImage,
  uploadNewsletterPdf,
};
